module.exports = __webpack_public_path__ + "img/рз_47.b55eaf5e.png";